export type Rule = {
  businessType: RuleBusinessType;
  description: string | null;
  id: string;
  code: string;
  implementationType: RuleImplementationType;
  name: string;
  query?: string;
};

export type RuleImplementationType = "predefined" | "userDefined";

export const RuleBusinessTypeValues = [
  "comparison",
  "velocity",
  "linkedCase",
  "blacklist",
] as const;

export type RuleBusinessType = (typeof RuleBusinessTypeValues)[number];
